import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SettingGroup } from '../../FormWidgets/SettingGroup';
import SimpleLightCurve from '../../components/SimpleLightCurve';
import { formatLightMinute, lightCycle } from '../../Utils/light_profiles';
import { legacyLightOutputVertices } from '../../Utils/light_profile_source';

export default function LegacyLightPreview({ timing, phase, minimum, maximum, sunriseDuration }) {
  const { t } = useTranslation();
  // Do not invent a midnight cycle while Time readback is missing or unreadable.
  if (!timing || !['start_day_hour', 'start_day_min', 'end_day_hour', 'end_day_min']
    .every((key) => Number.isFinite(timing[key])) || !Number.isFinite(minimum) || !Number.isFinite(maximum)) return null;
  const cycle = lightCycle(timing, phase);
  return (
    <SettingGroup label={t('lighting_simple_curve')} hideLabel>
      <Box px={2} py={1} width="100%">
        <Typography variant="body2">
          {t('lighting_day')} {formatLightMinute(cycle.start)} – {formatLightMinute(cycle.end)}
        </Typography>
        <SimpleLightCurve
          cycle={cycle}
          channel={{ maximum }}
          outputCurve={legacyLightOutputVertices({ cycle, minimum, maximum, sunriseDuration })}
        />
      </Box>
    </SettingGroup>
  );
}
